// test2060
(2060 && 0);
